import { useMutation } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

const updateObservationQuestion = async ({
	id,
	...payload
}: { id: number } & Partial<IAdminQuestion>) => {
	const url = `/observations/admin/questions/${id}/`;
	const response = await cmsClient.put<IAdminQuestion>(url, payload);

	return response.data;
};

const useUpdateObservationQuestion = () => {
	const mutation = useMutation(updateObservationQuestion);
	return mutation;
};

export default useUpdateObservationQuestion;
